import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contacts--title-spinner"
//
// React's LinkBillingAccountDrawer shows a spinner next to its title while a
// search is in flight (CONEK-8263). Ui::DrawerComponent renders the title as
// plain text, so the spinner is rendered hidden in the drawer body and moved
// next to the title on connect; the search form's submit-start / submit-end
// show and hide it.
export default class extends Controller {
  static targets = ["spinner"]
  static values = { titleId: String }

  connect() {
    document.getElementById(this.titleIdValue)?.append(this.spinnerTarget)
  }

  start() {
    this.spinnerTarget.hidden = false
  }

  stop() {
    this.spinnerTarget.hidden = true
  }
}
